import { format, isValid } from 'date-fns';
import axios from 'axios';

const getCurrentDate = () => {
    const today = new Date();
    const year = today.getFullYear();
    const month = `${today.getMonth() + 1}`.padStart(2, '0');
    const day = `${today.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
};



const getAddress = async (values, setValues, postalcodeValidation) => {
  if (!values.postalcode) {
    setValues((prevValues) => ({
      ...prevValues,
      street: '',
      city: '',
    }));
    return;
  }

  if (!postalcodeValidation.valid) return;

  try {
  const token = sessionStorage.getItem('jwtToken');

    const { data } = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}/api/postcode/address`,
      {
        params: {
          postcode: values.postalcode,
          number: values.housenr,
        },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );

    setValues((prevValues) => ({
      ...prevValues,
      street: data.street || '',
      city: data.city || '',
    }));
  } catch (error) {
    console.error('Error fetching address:', error);
    setValues((prevValues) => ({
      ...prevValues,
      street: '',
      city: '',
    }));
  }
};

const calculateAge=(birthdate) => {
    // Calculate age based on birthdate
    // You can use a library like 'date-fns' for more precise age calculation
    const birthYear = new Date(birthdate).getFullYear();
    const currentYear = new Date().getFullYear();
    return currentYear - birthYear;
}


const formatDate = (dateInput) => {
  if (!dateInput) {
    return '';
  }

  // Maak een Date-object als dateInput geen Date-object is
  const date = dateInput instanceof Date ? dateInput : new Date(dateInput);

  // Controleer of de datum geldig is en of deze niet overeenkomt met het jaar '1899'
  if (!isValid(date) || (typeof dateInput === 'string' && dateInput.includes('1899'))) {
    return '';
  }

  // Formatteer de datum in 'dd-MM-yyyy' formaat
  return format(date, 'dd-MM-yyyy');
};

export default formatDate;


const formatIsUser = (isUser) => {
  return isUser ? 'Ja' : 'Nee';
};

const logout=() => {
  console.log("Log out from system")
  sessionStorage.removeItem('jwtToken');

}

  export { getAddress, getCurrentDate,calculateAge,formatDate,formatIsUser,logout };